import React from 'react';
import { Box, styled, useTheme } from '@mui/material';

type PropTypes = {
  imageOne: string;
  imageTwo?: string;
  altOne?: string;
  altTwo?: string;
};

const ImagesWrapper = styled('div')(({ theme }) => ({
  width: theme.spacing(18),
  minWidth: theme.spacing(17),
  height: theme.spacing(18),
  minHeight: theme.spacing(17),
  aspectRatio: 1 / 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',

  '& img': {
    position: 'absolute',
    width: '80%',
  },

  '& .image-top': {
    left: theme.spacing(-1),
    top: theme.spacing(-1),
  },

  '& .image-bottom': {
    right: theme.spacing(-1),
    bottom: theme.spacing(-1),
    borderRadius: theme.spacing(0.5),
    boxShadow: '0 0 4px 4px rgba(8, 8, 8, 0.2)',
  },
}));

const Ring = styled('div')(() => ({
  width: '95%',
  height: '95%',
  border: '3px solid black',
  borderRadius: '50%',
}));

const ArticleImage = ({ imageOne, imageTwo, altOne, altTwo }: PropTypes) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        my: theme.spacing(3),
        py: theme.spacing(3),
        backgroundColor: theme.palette.grey[50],
      }}
    >
      <ImagesWrapper>
        {!imageTwo ? (
          <img src={imageOne} alt={altOne} />
        ) : (
          <>
            <img className="image-top" src={imageOne} alt={altOne} />
            <Ring />
            <img className="image-bottom" src={imageTwo} alt={altTwo} />
          </>
        )}
      </ImagesWrapper>
    </Box>
  );
};

export default ArticleImage;
